import Entity from './entity'
export default class WasteType extends Entity<number>{
    
    name:string;
   

}